'use strict';

export default class Component {
    constructor(element) {
        this.N = this.constructor.id++;
        
        this.container = element;
        this.container.setAttribute('data-id', this.N);
    }

    get id() {
        return this.N;
    }

    get element() {
        return this.container;
    }

    destroy() {
        this.container.removeAttribute('data-id');
    }
}



// WEBPACK FOOTER //
// ./app/general/js/generic.basecomponent.js